import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import { Link } from 'react-router-dom'
import { Collapse } from 'reactstrap'
class Menu extends Component {
  constructor (props) {
    super(props)
    this.handleToggle = this.handleToggle.bind(this)
    this.state = {
      isOpen: false
    }
  }

  handleToggle () {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render () {
    const items = this.props.items
    if (items.items.length === 0) {
      return (
        <li>
          <Link
            to={items.url}
            className='btn btn-default btn-flat btn-sidebar btn-sidebar-1'
          >
            <i className={items.icon} />
            <span className='title'>{items.title}</span>
            {items.badge &&
              <span className={`ml-auto ${items.badge.className}`}>{items.badge.title}</span>}
          </Link>
        </li>
      )
    } else {
      return (
        <li>
          <a
            className={
              this.state.isOpen
                ? 'btn btn-default btn-flat btn-sidebar btn-sidebar-1 has-children is-open'
                : 'btn btn-default btn-flat btn-sidebar btn-sidebar-1 has-children'
            }
            onClick={this.handleToggle}
          >
            <i className={items.icon} />
            <span className='title'>{items.title}</span>
            {items.badge &&
              <span className={`ml-auto ${items.badge.className}`}>{items.badge.title}</span>}
          </a>
          <Collapse isOpen={this.state.isOpen}>
            <ul className='list-unstyled'>
              {items.items.map(({ url, icon, title }, k) =>
                <li key={k}>
                  <Link
                    to={url}
                    className='btn btn-default btn-flat btn-sidebar btn-sidebar-2'
                  >
                    <i className={icon} />
                    <span className='title'>{title}</span>
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>
      )
    }
  }
}
export default Menu



// WEBPACK FOOTER //
// ./src/elements/Menu.js